import axios from "axios";

const scrollToTop = () => {
  try {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  } catch (error) {
    window.scrollTo(0, 0);
  }
};

const updateLocalStorageToken = (token) => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  userInfo.token = token
  const updatedUserInfo = JSON.stringify(userInfo);
  localStorage.setItem('userInfo', updatedUserInfo);
  axios.defaults.headers.common['Authorization'] = `Bearer ${userInfo.token}`;
}

const logOut = () => {
  localStorage.clear();
  window.location.href = '/login';
}

const fortmatDate = (date) => {
  if (date) {
    var d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }
  return '';
};

const formatMonthYear = (dateValue) => {
  if (!dateValue) return '';

  const value = String(dateValue);
  const datePart = value.split(' ')[0]?.split('T')[0];
  if (!datePart) return '';

  const [year, month, day] = datePart.split('-').map(Number);
  if (!year || !month || !day) return '';

  const d = new Date(year, month - 1, day);
  const dayStr = String(d.getDate()).padStart(2, '0');
  const monthNames = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];
  const monthStr = monthNames[d.getMonth()];
  const yearStr = d.getFullYear();

  return `${dayStr} de ${monthStr} del ${yearStr}`;
}

const removeLastSlashText = (text) => {
  return /\/\s*OPTION/i.test(text)
    ? text.replace(/\s*\/\s*OPTION.*$/i, '')
    : text;
}

const extractRoutes = (itinerary) => {
  const clean = removeLastSlashText(itinerary);

  const match = clean.match(/\/\s*(ROUTE.+)$/);
  if (!match) return [];

  const routesPart = match[1];
  return routesPart.split('+').map(r => r.trim());
}

const buildItinerary = (start, end, route) => {

  const days = Math.round((end.getTime() - start.getTime()) / (1000 * 3600 * 24)) + 1;
  const nights = days - 1;
  console.log(start, end, route)
  const startDay = start.toLocaleDateString('es-EC', { weekday: 'long' }).toUpperCase();
  const endDay = end.toLocaleDateString('es-EC', { weekday: 'long' }).toUpperCase();

  let itinerary = `${days} D - ${nights} N / ${startDay} - ${endDay}`;
  if (route) itinerary += ` / ${route}`;

  return itinerary.trim();
}

const convertToEnglish = (text) => {
  text = text.split("LUNES").join("MONDAY");
  text = text.split("MARTES").join("TUESDAY");
  text = text.split("MIÉRCOLES").join("WEDNESDAY");
  text = text.split("JUEVES").join("THURSDAY");
  text = text.split("VIERNES").join("FRIDAY");
  text = text.split("SÁBADO").join("SATURDAY");
  text = text.split("DOMINGO").join("SUNDAY");
  text = text.split("OPCIÓN").join("OPTION");
  text = text.split("RUTA").join("ROUTE");
  text = text.split("CRUCERO CORTADO").join("SPLIT CRUISE");
  return text;
}

export {
  scrollToTop,
  updateLocalStorageToken,
  fortmatDate,
  formatMonthYear,
  logOut,
  removeLastSlashText,
  extractRoutes,
  buildItinerary,
  convertToEnglish
};